import React, { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router';

import { getLandingPageRedirect } from '../../shared/LandingPageRedirects';
import { getConfig } from '../config';

// Match server destinations when navigation is handled by the client router.
const MissingPageRedirect = () => {
  const { pathname, search } = useLocation();
  const target =
    getLandingPageRedirect(pathname, getConfig().COUNTRY)?.target || '/404';

  useEffect(() => {
    if (target !== '/404') {
      window.location.replace(`${target}${search}`);
    }
  }, [target, search]);

  if (target !== '/404') return null;

  return <Redirect to={{ pathname: target, search }} />;
};

export default MissingPageRedirect;
